import { PlaygroundUsersOut, UserOut } from 'lib/apiClient'

export const getFullUserName = (user: UserOut | PlaygroundUsersOut | null) =>
  user ? [user?.firstName, user?.lastName].filter(Boolean).join(' ') : 'Unknown User'
